import React, { useState } from 'react';
import { Modal } from '../Modal';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { Form } from 'antd';
import { attachPaymentMethod } from "../../services/account/api"
import { FormattedMessage } from 'react-intl';

function CreatePaymentMethodModal({ open, onCancel, onFinish }) {
  const stripe = useStripe();
  const elements = useElements();

  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState('');
  const [disabled, setDisabled] = useState(true);

  const cardStyle = {
    style: {
      base: {
        color: "#32325d",
        fontFamily: 'Arial, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#32325d"
        }
      },
      invalid: {
        fontFamily: 'Arial, sans-serif',
        color: "#fa755a",
        iconColor: "#fa755a"
      }
    }
  };

  const handleChange = async (event) => {
    // Listen for changes in the CardElement
    // and display any errors as the customer types their card details
    setDisabled(event.empty);
    setError(event.error ? event.error.message : "");
  };


  const handleSubmit = async ev => {
    ev.preventDefault();
    setProcessing(true);

    const payload = await stripe.createPaymentMethod({
      type: 'card',
      card: elements.getElement(CardElement),
    });

    if (payload.error) {
      setError(payload.error.message);
      setProcessing(false);
    } else {
      await attachPaymentMethod(payload)
        .then((res) => {
          setSucceeded(true);
          onFinish();
          onCancel();
        })
        .catch((err) => {
          setError(`${err.response.data.message}`);
        })
        .finally(() => {
          setProcessing(false);
        })
    }
  };


  return (
    <Modal.Root visible={open}>
      <Modal.Header
        onCancelAction={onCancel}
        title={<FormattedMessage id="page.my_account.financial.payment_methods.modal.title" />}
      />
      <Modal.Content>
        {error && (
          <div className="py-2 card-error" role="alert">
            {error}
          </div>
        )}
        <Form layout='vertical'>
          <Form.Item>
            <CardElement id="card-element" options={cardStyle} onChange={handleChange} />
          </Form.Item>
        </Form>
      </Modal.Content>
      <Modal.Actions
        submitText={<FormattedMessage id="page.my_account.financial.payment_methods.modal.action" />}
        onSubmitAction={handleSubmit}
        onCancelAction={onCancel}
        disabled={processing || disabled || succeeded}
        success={succeeded}
        loading={!!processing}
      />

    </Modal.Root>
  );
}

export default CreatePaymentMethodModal;